import { cn } from '@/lib/utils';
import { useStudioStore } from '@/store/useStudioStore';

/**
 * Studio 工作台预览加载骨架屏
 */
export const StudioPreviewSkeleton = () => {
  const { previewDevice } = useStudioStore();

  return (
    <div className="animate-in fade-in relative flex h-full min-h-0 flex-1 flex-col overflow-hidden bg-[#EDEEF6] duration-500">
      <div className="preview-scroll flex flex-1 justify-center overflow-auto bg-[#EDEEF6] p-6">
        <div
          className={cn(
            'preview-frame-shell relative w-full max-w-[1200px] overflow-hidden rounded-lg bg-white shadow-2xl transition-all duration-300 ease-in-out',
            previewDevice === 'mobile' &&
              'max-w-[390px] rounded-[32px] border-[8px] border-slate-900 shadow-slate-900/10',
            previewDevice === 'tablet' && 'max-w-[768px] rounded-xl',
          )}
          style={{ minHeight: '800px' }}
        >
          <div className="p-8">
            <div className="mb-12 h-8 w-32 rounded bg-slate-100" />
            <div className="max-w-md space-y-4">
              <div className="h-12 w-full rounded bg-slate-50" />
              <div className="h-4 w-2/3 rounded bg-slate-50" />
            </div>
            <div className="mt-12 grid grid-cols-3 gap-4">
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="h-40 rounded-xl border border-dashed border-slate-200 bg-slate-50"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
